import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authContainer } from '@/modules/auth/di/container';
import { useAuthStore } from '@/modules/auth/presentation/store/auth.store';

/**
 * Consome o SSO handoff vindo do admin-dashboard: lê o custom token do fragmento
 * da URL (`/handoff#ct=...`), troca-o por uma sessão Firebase e redireciona para
 * a home. O token vai no fragmento (não em query string) para não vazar em logs
 * de servidor/histórico enviado ao backend.
 */
export function HandoffPage() {
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();
  const [error, setError] = useState(false);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const customToken = params.get('ct');

    // Limpa o fragmento da barra de endereço (não deixa o token no histórico).
    window.history.replaceState(null, '', window.location.pathname);

    if (!customToken) {
      void navigate('/sign-in', { replace: true });
      return;
    }

    void (async () => {
      try {
        const data =
          await authContainer.repository.signInWithCustomToken(customToken);
        const accessToken = data.accessToken ?? data.tokens?.accessToken ?? '';
        const accountId = data.account?.id ?? data.user?.id ?? '';
        const email = data.account?.email ?? data.user?.email ?? '';
        setAuth({ accessToken, accountId, email });
        void navigate('/profile', { replace: true });
      } catch (err) {
        console.error('Falha no handoff SSO', err);
        setError(true);
      }
    })();
  }, [navigate, setAuth]);

  return (
    <div className="bg-(--color-bg-secondary) flex min-h-screen items-center justify-center p-6">
      {error ? (
        <div className="text-center">
          <p className="text-(--color-text-primary) text-sm font-medium">
            Não foi possível concluir o login.
          </p>
          <button
            onClick={() => navigate('/sign-in', { replace: true })}
            className="text-(--color-accent) mt-3 text-sm font-medium hover:underline"
          >
            Ir para o login
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3">
          <div className="border-(--color-accent) h-8 w-8 animate-spin rounded-full border-2 border-t-transparent" />
          <p className="text-(--color-text-secondary) text-sm">Entrando…</p>
        </div>
      )}
    </div>
  );
}
